module.exports = __webpack_public_path__ + "img/mel_skyline.aa820448.jpg";